export default {
  notfound: {
    title: 'Cette page n’a pas encore été générée',
    hint: 'Parlez-moi davantage de cette page pour que je puisse la générer',
  },
};